export const UnauthorizedPage = () => {
  return (
    <div>
      The page you are trying to view is not available to you in your current
      role
    </div>
  );
};
